export default "__VITE_ASSET__DK96u7Vq__"